import { render, staticRenderFns } from "./AnnouncementsCreate.vue?vue&type=template&id=d196171e&"
import script from "./AnnouncementsCreate.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports